import { initClient, initClientNavigation } from "rwsdk/client";

const { handleResponse } = initClientNavigation();
void initClient({ handleResponse });
